"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixClientEventEmitter = void 0;
const events_1 = require("events");
const utils_1 = require("../utils/utils");
const MatrixRoom_1 = require("./models/MatrixRoom");
const MatrixClientEvent_1 = require("./models/MatrixClientEvent");
class MatrixClientEventEmitter extends events_1.EventEmitter {
    constructor() {
        super(...arguments);
        this.eventEmitProviders = new Map([
            [MatrixClientEvent_1.MatrixClientEventType.INVITE, () => [this.isInvite, this.emitInvite.bind(this)]],
            [MatrixClientEvent_1.MatrixClientEventType.MESSAGE, () => [this.isMessage, this.emitMessage.bind(this)]]
        ]);
    }
    onStateChanged(_oldState, _newState, stateChange) {
        for (const event of utils_1.keys(MatrixClientEvent_1.MatrixClientEventType)) {
            this.emitIfEvent(MatrixClientEvent_1.MatrixClientEventType[event], stateChange);
        }
    }
    emitIfEvent(eventType, object) {
        const provider = this.eventEmitProviders.get(eventType);
        if (provider) {
            const [predicate, emitter] = provider();
            if (predicate(object)) {
                emitter(eventType, object);
            }
        }
    }
    emitClientEvent(eventType, content) {
        this.emit(eventType, {
            type: eventType,
            content
        });
    }
    isInvite(stateChange) {
        return stateChange.rooms
            ? stateChange.rooms.some((room) => room.status === MatrixRoom_1.MatrixRoomStatus.INVITED)
            : false;
    }
    emitInvite(eventType, stateChange) {
        stateChange.rooms
            .filter((room) => room.status === MatrixRoom_1.MatrixRoomStatus.INVITED)
            .map((room) => room.id)
            .forEach((id) => {
            this.emitClientEvent(eventType, {
                roomId: id
            });
        });
    }
    isMessage(stateChange) {
        return stateChange.rooms ? stateChange.rooms.some((room) => room.messages.length > 0) : false;
    }
    emitMessage(eventType, stateChange) {
        stateChange.rooms
            .filter((room) => room.messages.length > 0)
            .map((room) => room.messages.map((message) => [room.id, message]))
            .reduce((flatten, toFlatten) => flatten.concat(toFlatten), [])
            .forEach(([roomId, message]) => {
            this.emitClientEvent(eventType, {
                roomId,
                message
            });
        });
    }
}
exports.MatrixClientEventEmitter = MatrixClientEventEmitter;
//# sourceMappingURL=MatrixClientEventEmitter.js.map